/* Layout "Luz Editorial" — menu mobile, busca e abas da vitrine */
(function () {
  'use strict';
  function once(el, fn) { if (el.dataset.edReady) return; el.dataset.edReady = '1'; fn(el); }

  function initDrawer() {
    var drawer = document.getElementById('ed-drawer');
    var overlay = document.querySelector('.ed-overlay');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-ed-drawer-open]');
    function set(open) {
      drawer.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      openers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openers.forEach(function (b) { once(b, function () { b.addEventListener('click', function () { set(true); }); }); });
    document.querySelectorAll('[data-ed-drawer-close]').forEach(function (b) { once(b, function () { b.addEventListener('click', function () { set(false); }); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  function initSearch() {
    document.querySelectorAll('[data-ed-search-toggle]').forEach(function (btn) {
      once(btn, function () {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          var open = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', String(open));
          if (open) { var input = panel.querySelector('input[type="search"]'); if (input) input.focus(); }
        });
      });
    });
  }

  var ON = ['border-[#D9A45B]', 'font-semibold', 'text-[#111F46]'];
  var OFF = ['border-transparent', 'font-medium', 'text-[#2B2D35]/60'];
  function initTabs() {
    document.querySelectorAll('[data-ed-tabs]').forEach(function (root) {
      once(root, function () {
        var tabs = root.querySelectorAll('[data-ed-tab]');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (t) {
              var active = t === tab;
              t.setAttribute('aria-selected', String(active));
              ON.forEach(function (c) { t.classList.toggle(c, active); });
              OFF.forEach(function (c) { t.classList.toggle(c, !active); });
            });
            root.querySelectorAll('[data-ed-panel]').forEach(function (p) {
              p.hidden = p.dataset.edPanel !== tab.dataset.edTab;
            });
          });
        });
      });
    });
  }

  function init() { initDrawer(); initSearch(); initTabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
